module.exports = [
	{
		"id": 0,
		"category_name": "Quizes",
		"cost": 188,
		"CPV": 59,
		"EPV": 67,
		"profit": 198,
		"revenue": 76,
		"CR": 82.34,
		"CTR": 14.14,
		"CV": 22.64,
		"clicks": 166,
		"visits": 267,
		"status": "archived",
		"symbol": "0xuDr",
		"is_favorite": true,
		"users": [
			{
				"avatar_tag": "raccoon",
				"email": "ujo@nur.io"
			},
			{
				"avatar_tag": "sheep",
				"email": "zu@gedcizole.co.uk"
			},
			{
				"avatar_tag": "cat",
				"email": "matajdog@ti.org"
			}
		]
	},
	{
		"id": 1,
		"category_name": "Cloaked",
		"cost": 79,
		"CPV": 197,
		"EPV": 26,
		"profit": 94,
		"revenue": 81,
		"CR": 57.42,
		"CTR": 73.54,
		"CV": 9.56,
		"clicks": 88,
		"visits": 278,
		"status": "archived",
		"symbol": "g7roN",
		"is_favorite": true,
		"users": [
			{
				"avatar_tag": "cat",
				"email": "ziflackac@canwurur.org"
			},
			{
				"avatar_tag": "pig",
				"email": "jimkame@buzke.co.uk"
			},
			{
				"avatar_tag": "lion",
				"email": "kodde@kig.edu"
			}
		]
	},
	{
		"id": 2,
		"category_name": "Tests",
		"cost": 91,
		"CPV": 3,
		"EPV": 111,
		"profit": 189,
		"revenue": 43,
		"CR": 42.05,
		"CTR": 27.25,
		"CV": 30.33,
		"clicks": 358,
		"visits": 386,
		"status": "aсtive",
		"symbol": "U8TS1",
		"is_favorite": true,
		"users": [
			{
				"avatar_tag": "cat",
				"email": "edcemvoj@arudo.co.uk"
			},
			{
				"avatar_tag": "pig",
				"email": "abaoka@kec.net"
			},
			{
				"avatar_tag": "koala",
				"email": "cebe@giweak.org"
			},
			{
				"avatar_tag": "pig",
				"email": "muzebusu@piovoos.com"
			}
		]
	},
	{
		"id": 3,
		"category_name": "Tests",
		"cost": 180,
		"CPV": 179,
		"EPV": 48,
		"profit": 67,
		"revenue": 20,
		"CR": 12.65,
		"CTR": 12.25,
		"CV": 58.17,
		"clicks": 172,
		"visits": 174,
		"status": "archived",
		"symbol": "VNipi",
		"is_favorite": true,
		"users": [
			{
				"avatar_tag": "fox",
				"email": "zag@vubna.edu"
			}
		]
	},
	{
		"id": 4,
		"category_name": "Quizes",
		"cost": 177,
		"CPV": 12,
		"EPV": 185,
		"profit": 99,
		"revenue": 130,
		"CR": 33.92,
		"CTR": 82.63,
		"CV": 78.93,
		"clicks": 459,
		"visits": 170,
		"status": "aсtive",
		"symbol": "G09IT",
		"is_favorite": false,
		"users": [
			{
				"avatar_tag": "cat",
				"email": "ju@padhuwi.org"
			},
			{
				"avatar_tag": "lion",
				"email": "sozgej@fekacpop.net"
			}
		]
	},
	{
		"id": 5,
		"category_name": "Tests",
		"cost": 115,
		"CPV": 108,
		"EPV": 96,
		"profit": 136,
		"revenue": 71,
		"CR": 57.94,
		"CTR": 96.7,
		"CV": 44.11,
		"clicks": 317,
		"visits": 164,
		"status": "aсtive",
		"symbol": "yaRCb",
		"is_favorite": false,
		"users": [
			{
				"avatar_tag": "koala",
				"email": "orogigvep@koh.com"
			},
			{
				"avatar_tag": "lion",
				"email": "jozsote@bib.com"
			},
			{
				"avatar_tag": "fox",
				"email": "luzis@teboba.edu"
			},
			{
				"avatar_tag": "owl",
				"email": "fagak@ce.gov"
			}
		]
	},
	{
		"id": 6,
		"category_name": "Cloaked",
		"cost": 34,
		"CPV": 48,
		"EPV": 159,
		"profit": 133,
		"revenue": 5,
		"CR": 10.69,
		"CTR": 70.7,
		"CV": 86.33,
		"clicks": 185,
		"visits": 288,
		"status": "archived",
		"symbol": "c1BRX",
		"is_favorite": false,
		"users": [
			{
				"avatar_tag": "cat",
				"email": "jefewlot@iz.edu"
			},
			{
				"avatar_tag": "pig",
				"email": "gedo@ef.org"
			}
		]
	},
	{
		"id": 7,
		"category_name": "Tests",
		"cost": 192,
		"CPV": 58,
		"EPV": 7,
		"profit": 137,
		"revenue": 22,
		"CR": 98.26,
		"CTR": 76.15,
		"CV": 90.89,
		"clicks": 451,
		"visits": 231,
		"status": "archived",
		"symbol": "d0qgc",
		"is_favorite": true,
		"users": [
			{
				"avatar_tag": "fox",
				"email": "ugso@coshifo.io"
			},
			{
				"avatar_tag": "owl",
				"email": "curiuzu@fohashot.co.uk"
			},
			{
				"avatar_tag": "lion",
				"email": "fepe@dibbi.net"
			},
			{
				"avatar_tag": "fox",
				"email": "igu@haziri.net"
			}
		]
	},
	{
		"id": 8,
		"category_name": "Cloaked",
		"cost": 109,
		"CPV": 148,
		"EPV": 150,
		"profit": 135,
		"revenue": 136,
		"CR": 24.23,
		"CTR": 54.62,
		"CV": 45.16,
		"clicks": 49,
		"visits": 94,
		"status": "archived",
		"symbol": "VNlHV",
		"is_favorite": false,
		"users": [
			{
				"avatar_tag": "cat",
				"email": "kigdif@vimsouno.net"
			},
			{
				"avatar_tag": "lion",
				"email": "dumeb@buftod.com"
			}
		]
	},
	{
		"id": 9,
		"category_name": "Cloaked",
		"cost": 126,
		"CPV": 53,
		"EPV": 149,
		"profit": 129,
		"revenue": 175,
		"CR": 53.07,
		"CTR": 10.3,
		"CV": 65.37,
		"clicks": 437,
		"visits": 56,
		"status": "aсtive",
		"symbol": "wqWUU",
		"is_favorite": false,
		"users": [
			{
				"avatar_tag": "cat",
				"email": "vedmaav@caf.co.uk"
			},
			{
				"avatar_tag": "pig",
				"email": "limfojubi@lehgumnok.org"
			},
			{
				"avatar_tag": "sheep",
				"email": "minome@ino.edu"
			}
		]
	},
	{
		"id": 10,
		"category_name": "Quizes",
		"cost": 100,
		"CPV": 112,
		"EPV": 193,
		"profit": 87,
		"revenue": 167,
		"CR": 53.34,
		"CTR": 88.92,
		"CV": 95.56,
		"clicks": 52,
		"visits": 244,
		"status": "archived",
		"symbol": "Rrz33",
		"is_favorite": false,
		"users": [
			{
				"avatar_tag": "sheep",
				"email": "ketuusu@liguebu.org"
			}
		]
	},
	{
		"id": 11,
		"category_name": "Quizes",
		"cost": 127,
		"CPV": 1,
		"EPV": 70,
		"profit": 116,
		"revenue": 66,
		"CR": 15.97,
		"CTR": 34.63,
		"CV": 32.02,
		"clicks": 249,
		"visits": 256,
		"status": "aсtive",
		"symbol": "MyBPD",
		"is_favorite": false,
		"users": [
			{
				"avatar_tag": "fox",
				"email": "mocot@elu.edu"
			},
			{
				"avatar_tag": "raccoon",
				"email": "jolitfic@avfasbon.io"
			},
			{
				"avatar_tag": "koala",
				"email": "vecoh@ofuocapos.gov"
			},
			{
				"avatar_tag": "cat",
				"email": "wedrew@mutpag.co.uk"
			}
		]
	},
	{
		"id": 12,
		"category_name": "Cloaked",
		"cost": 58,
		"CPV": 41,
		"EPV": 189,
		"profit": 155,
		"revenue": 12,
		"CR": 81.08,
		"CTR": 42.13,
		"CV": 100.28,
		"clicks": 6,
		"visits": 132,
		"status": "archived",
		"symbol": "NYWH0",
		"is_favorite": true,
		"users": [
			{
				"avatar_tag": "koala",
				"email": "kud@ri.io"
			}
		]
	},
	{
		"id": 13,
		"category_name": "Quizes",
		"cost": 124,
		"CPV": 80,
		"EPV": 126,
		"profit": 64,
		"revenue": 62,
		"CR": 42.1,
		"CTR": 98.08,
		"CV": 29.92,
		"clicks": 177,
		"visits": 388,
		"status": "aсtive",
		"symbol": "teWuh",
		"is_favorite": false,
		"users": [
			{
				"avatar_tag": "owl",
				"email": "cajsabiku@ivoliju.co.uk"
			},
			{
				"avatar_tag": "owl",
				"email": "noej@cijhufu.gov"
			},
			{
				"avatar_tag": "dog",
				"email": "de@fiwin.gov"
			},
			{
				"avatar_tag": "lion",
				"email": "woucum@bi.net"
			}
		]
	},
	{
		"id": 14,
		"category_name": "Tests",
		"cost": 145,
		"CPV": 129,
		"EPV": 1,
		"profit": 86,
		"revenue": 112,
		"CR": 55.84,
		"CTR": 16.79,
		"CV": 70.61,
		"clicks": 475,
		"visits": 50,
		"status": "aсtive",
		"symbol": "6peIE",
		"is_favorite": true,
		"users": [
			{
				"avatar_tag": "pig",
				"email": "narog@ruwe.com"
			}
		]
	},
	{
		"id": 15,
		"category_name": "Tests",
		"cost": 6,
		"CPV": 115,
		"EPV": 135,
		"profit": 99,
		"revenue": 108,
		"CR": 79.53,
		"CTR": 52.19,
		"CV": 86.08,
		"clicks": 2,
		"visits": 20,
		"status": "aсtive",
		"symbol": "t6Ear",
		"is_favorite": true,
		"users": [
			{
				"avatar_tag": "owl",
				"email": "oba@ha.com"
			}
		]
	},
	{
		"id": 16,
		"category_name": "Tests",
		"cost": 196,
		"CPV": 129,
		"EPV": 55,
		"profit": 174,
		"revenue": 54,
		"CR": 15.48,
		"CTR": 22.85,
		"CV": 20.17,
		"clicks": 326,
		"visits": 127,
		"status": "archived",
		"symbol": "Y46Kq",
		"is_favorite": false,
		"users": [
			{
				"avatar_tag": "sheep",
				"email": "cahluc@vah.edu"
			},
			{
				"avatar_tag": "raccoon",
				"email": "api@cesucewo.edu"
			},
			{
				"avatar_tag": "owl",
				"email": "ocifarmuk@nu.edu"
			},
			{
				"avatar_tag": "penguin",
				"email": "gana@nikov.org"
			}
		]
	},
	{
		"id": 17,
		"category_name": "Cloaked",
		"cost": 111,
		"CPV": 187,
		"EPV": 10,
		"profit": 151,
		"revenue": 85,
		"CR": 69.43,
		"CTR": 85.54,
		"CV": 21.91,
		"clicks": 38,
		"visits": 260,
		"status": "aсtive",
		"symbol": "x8sR6",
		"is_favorite": false,
		"users": [
			{
				"avatar_tag": "owl",
				"email": "wi@duc.org"
			},
			{
				"avatar_tag": "owl",
				"email": "tuim@cem.gov"
			}
		]
	},
	{
		"id": 18,
		"category_name": "Quizes",
		"cost": 199,
		"CPV": 134,
		"EPV": 177,
		"profit": 180,
		"revenue": 37,
		"CR": 26.29,
		"CTR": 19.49,
		"CV": 87.92,
		"clicks": 486,
		"visits": 450,
		"status": "archived",
		"symbol": "yeNRD",
		"is_favorite": true,
		"users": [
			{
				"avatar_tag": "lion",
				"email": "damjelu@we.net"
			}
		]
	},
	{
		"id": 19,
		"category_name": "Quizes",
		"cost": 163,
		"CPV": 21,
		"EPV": 14,
		"profit": 52,
		"revenue": 68,
		"CR": 85.92,
		"CTR": 85.65,
		"CV": 34.37,
		"clicks": 398,
		"visits": 477,
		"status": "archived",
		"symbol": "ADP0T",
		"is_favorite": true,
		"users": [
			{
				"avatar_tag": "owl",
				"email": "negha@ce.org"
			},
			{
				"avatar_tag": "penguin",
				"email": "ar@mubig.edu"
			},
			{
				"avatar_tag": "raccoon",
				"email": "zajaz@kurofmek.co.uk"
			},
			{
				"avatar_tag": "sheep",
				"email": "umbogij@ijgetif.gov"
			}
		]
	},
	{
		"id": 20,
		"category_name": "Quizes",
		"cost": 30,
		"CPV": 64,
		"EPV": 26,
		"profit": 14,
		"revenue": 175,
		"CR": 7.01,
		"CTR": 18.84,
		"CV": 96.07,
		"clicks": 496,
		"visits": 262,
		"status": "aсtive",
		"symbol": "YiMWl",
		"is_favorite": false,
		"users": [
			{
				"avatar_tag": "koala",
				"email": "maeb@nep.edu"
			},
			{
				"avatar_tag": "cat",
				"email": "he@suzum.co.uk"
			},
			{
				"avatar_tag": "lion",
				"email": "te@wamizoh.org"
			}
		]
	},
	{
		"id": 21,
		"category_name": "Tests",
		"cost": 70,
		"CPV": 90,
		"EPV": 184,
		"profit": 83,
		"revenue": 183,
		"CR": 87.21,
		"CTR": 42.3,
		"CV": 77.19,
		"clicks": 275,
		"visits": 401,
		"status": "archived",
		"symbol": "yOJsJ",
		"is_favorite": true,
		"users": [
			{
				"avatar_tag": "owl",
				"email": "fawit@hadbajros.co.uk"
			},
			{
				"avatar_tag": "pig",
				"email": "kauwi@zazimi.io"
			}
		]
	},
	{
		"id": 22,
		"category_name": "Tests",
		"cost": 37,
		"CPV": 199,
		"EPV": 93,
		"profit": 8,
		"revenue": 59,
		"CR": 79.74,
		"CTR": 93.6,
		"CV": 1.52,
		"clicks": 151,
		"visits": 451,
		"status": "archived",
		"symbol": "DGwuD",
		"is_favorite": true,
		"users": [
			{
				"avatar_tag": "penguin",
				"email": "ta@ciguh.co.uk"
			}
		]
	},
	{
		"id": 23,
		"category_name": "Tests",
		"cost": 45,
		"CPV": 36,
		"EPV": 160,
		"profit": 181,
		"revenue": 170,
		"CR": 68.31,
		"CTR": 98.69,
		"CV": 42.42,
		"clicks": 178,
		"visits": 38,
		"status": "aсtive",
		"symbol": "JIy9w",
		"is_favorite": true,
		"users": [
			{
				"avatar_tag": "penguin",
				"email": "egbe@mekesiob.io"
			},
			{
				"avatar_tag": "penguin",
				"email": "astobeso@move.gov"
			}
		]
	},
	{
		"id": 24,
		"category_name": "Cloaked",
		"cost": 120,
		"CPV": 194,
		"EPV": 182,
		"profit": 172,
		"revenue": 153,
		"CR": 40.48,
		"CTR": 57.49,
		"CV": 23.6,
		"clicks": 193,
		"visits": 449,
		"status": "aсtive",
		"symbol": "u3h4X",
		"is_favorite": false,
		"users": [
			{
				"avatar_tag": "koala",
				"email": "zudseviw@vuwku.com"
			},
			{
				"avatar_tag": "dog",
				"email": "pe@rebmitgij.org"
			}
		]
	},
	{
		"id": 25,
		"category_name": "Quizes",
		"cost": 152,
		"CPV": 31,
		"EPV": 56,
		"profit": 108,
		"revenue": 63,
		"CR": 21.47,
		"CTR": 88.9,
		"CV": 27.64,
		"clicks": 259,
		"visits": 245,
		"status": "aсtive",
		"symbol": "osjjC",
		"is_favorite": true,
		"users": [
			{
				"avatar_tag": "sheep",
				"email": "jiol@sad.com"
			}
		]
	},
	{
		"id": 26,
		"category_name": "Quizes",
		"cost": 78,
		"CPV": 43,
		"EPV": 120,
		"profit": 115,
		"revenue": 62,
		"CR": 15.93,
		"CTR": 98.53,
		"CV": 94.96,
		"clicks": 56,
		"visits": 484,
		"status": "aсtive",
		"symbol": "E8dXe",
		"is_favorite": false,
		"users": [
			{
				"avatar_tag": "owl",
				"email": "ic@degajwa.gov"
			}
		]
	},
	{
		"id": 27,
		"category_name": "Quizes",
		"cost": 176,
		"CPV": 102,
		"EPV": 132,
		"profit": 32,
		"revenue": 149,
		"CR": 13.12,
		"CTR": 51.25,
		"CV": 44.09,
		"clicks": 432,
		"visits": 157,
		"status": "archived",
		"symbol": "Xn12u",
		"is_favorite": false,
		"users": [
			{
				"avatar_tag": "sheep",
				"email": "pa@zipecocar.co.uk"
			}
		]
	},
	{
		"id": 28,
		"category_name": "Cloaked",
		"cost": 22,
		"CPV": 117,
		"EPV": 126,
		"profit": 162,
		"revenue": 156,
		"CR": 74.83,
		"CTR": 34.94,
		"CV": 86.74,
		"clicks": 300,
		"visits": 230,
		"status": "archived",
		"symbol": "kkvwz",
		"is_favorite": false,
		"users": [
			{
				"avatar_tag": "owl",
				"email": "lu@si.org"
			},
			{
				"avatar_tag": "dog",
				"email": "nu@dap.gov"
			},
			{
				"avatar_tag": "dog",
				"email": "aj@lot.org"
			}
		]
	},
	{
		"id": 29,
		"category_name": "Quizes",
		"cost": 114,
		"CPV": 31,
		"EPV": 165,
		"profit": 80,
		"revenue": 59,
		"CR": 19.4,
		"CTR": 73.42,
		"CV": 80.8,
		"clicks": 305,
		"visits": 85,
		"status": "aсtive",
		"symbol": "AZqbQ",
		"is_favorite": false,
		"users": [
			{
				"avatar_tag": "pig",
				"email": "isderec@ralegad.gov"
			}
		]
	}
];


//////////////////
// WEBPACK FOOTER
// ./utils/fake_data.json
// module id = 230
// module chunks = 0